import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import DestinationActions from '../../Redux/DestinationRedux'

class CreateMapping extends React.Component {
  constructor (props) {
    super (props)
    this.state = {
      country: '',
      destination: ''
    }
  }

  componentDidMount = () => {
    this.props.getDestination()
  }

  _inputChange = (event, field) => {
    let newState = {...this.state}
    newState[field] = event.target.value.replace(/[^\x20-\x7E]/g, '')
    this.setState(newState)
  }

  _submit = (event) => {
    event.preventDefault()
    const content = {
      country_id: this.state.country.value,
    }

    this.props.submit(this.state.destination.value, content)
    this.props.closeModal()
  }

  render() {
    // const { files } = this.state
    const { country_list, data } = this.props

    let countries = []
    country_list.map((item, i) => {
      countries[i] = {
        value: item.id,
        label: item.name
      }
      return countries
    })

    let destinations = []
    data.map((item, i) => {
      destinations[i] = {
        value: item.id,
        label: item.name
      }
      return destinations
    })

    return (
      <div className="section" style={{ width: '40vw' }}>
        <div className="title-block">
          <h4 className="title mr-auto">Map Destination to Continent</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div>
            <div className="form-group row">
              <div className="col-3">
                <label htmlFor="country" className="control-label">Country</label>
              </div>
              <div className="col-9">
                <Select options={countries} value={this.state.country} required onChange={(country) => this.setState({ country })}/>
                <input value={this.state.country} required style={{ position: 'absolute', zIndex: '-1', top: 0, left: '30%' }}/>
              </div>
            </div>
            <div className="form-group row">
              <div className="col-3">
                <label htmlFor="destinations" className="control-label">Destinations</label>
              </div>
              <div className="col-9">
                <Select options={destinations} value={this.state.destination} required onChange={(destination) => this.setState({ destination })}/>
                <input value={this.state.destination} required style={{ position: 'absolute', zIndex: '-1', top: 0, left: '30%' }}/>
              </div>
            </div>
          </div>
          <div className="form-group d-flex justify-content-end">
            <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this.props.closeModal()}>Close</button>
            <button
              className="btn btn-lg btn-primary"
              type="submit"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  data: state.destination.data,
  processing: state.destination.processing,
  success: state.destination.success,
  error: state.destination.err,
  country_list: state.preset.dataCountries
})

const dispatchToProps = (dispatch) => ({
  getDestination: () => dispatch(DestinationActions.destinationRequest()),
  submit: (id, content) => dispatch(DestinationActions.destinationUpdateRequest({id, content})),
})

export default connect(stateToProps, dispatchToProps)(CreateMapping)



// WEBPACK FOOTER //
// ./src/Containers/Destination/CreateMapping.js